import REQUEST, { _createVehiclesRequest, _createUsersRequest } from '../shared/http-request-util'

export const persistVehicleData = async (body) => {
  try {
    const result = await _createUsersRequest().post('/persist', body)
    if (result && result.data) {
      return result.data;
    }
    return null;
  } catch (error) {
    console.error(`ERROR -> `, error);    // ***
    REQUEST()._handleErrorRedirect(error)
    return error;
  }
};

export const removeVehicleData = async (vehicleId) => {
  try {
    const result = await _createUsersRequest().delete(`/garage/${vehicleId}`)
    console.log('Result model', result);
    if (result && result.data) {
      return result.data;
    }
    return null;
  } catch (error) {
    console.error(`ERROR -> `, error);    // ***
    REQUEST()._handleErrorRedirect(error)
    return error;
  }
};

export const getVehicleData = async (selectedVin) => {
  try {
    const result = await _createVehiclesRequest().get(`/${selectedVin}`)
    if (result && result.data) {
      return result.data;
    }
    return null;
  } catch (error) {
    console.error(`ERROR -> `, error.response.data);    // ***
    REQUEST()._handleErrorRedirect(error)
    return error;
  }
};
